import { Box, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import MainButton from "../../../../shared/components/MainButton";
import Text from "../../../../shared/components/Text";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { validateKeyboardInputDate } from "../../../../../utils/validations";
import { parseStringAmountWithUnitToNumber } from "../../../../../utils/formaters";
import {
  assetIds,
  InputDate,
  RichTextfield,
  ThemedAsset,
} from "nemuru-components";
import IconTitle from "../../../../shared/components/IconTitle";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";

export default function ProfessionalDataSelfEmployedForm({
  onSubmitForm,
  data,
}) {
  const {
    state: { dictionaryValues },
  } = useContext(ConfigContext);
  const { palette, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("xs"));

  const { register, getValues, handleSubmit, errors, control } = useForm({
    defaultValues: {
      selfEmploymentNetIncomeValue: data?.selfEmploymentNetIncomeValue || "",
      selfEmploymentNetIncomeDate: data?.selfEmploymentNetIncomeDate || "",
    },
    reValidateMode: "onBlur",
  });

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_PROFESSIONAL_DATA}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="PROFESSIONAL_DATA" />}
          subtitle={<Text tId="SELF_EMPLOYED_DATA" />}
        />
        <RichTextfield
          defaultValue={parseStringAmountWithUnitToNumber(
            data?.selfEmploymentNetIncomeValue
          )}
          allowDecimals
          hideIcon
          unitName={"€"}
          fullWidth
          label={<Text tId={"INDIVIDUAL_NET_INCOME"} />}
          id="selfEmploymentNetIncomeValue"
          name="selfEmploymentNetIncomeValue"
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
              validate: {
                validate: (value) => {
                  const minimumIncome = 300;
                  const incomeInt = parseStringAmountWithUnitToNumber(value);
                  if (incomeInt < minimumIncome) {
                    return (
                      <Text
                        tId={"INCOME_AMOUNT_GREATER_THAN_VALUE"}
                        dynamicDataTexts={[minimumIncome]}
                      />
                    );
                  }
                },
              },
            }),
          }}
          error={errors.selfEmploymentNetIncomeValue ? true : false}
          helperText={errors.selfEmploymentNetIncomeValue?.message}
        />
        <InputDate
          allowKeyboardPicking={!isMobile}
          locale={dictionaryValues["DATE_LOCALE"]}
          emptyLabel={dictionaryValues["DATE_FORMAT_YEAR"]}
          control={control}
          fullWidth
          variant="inline"
          openTo="year"
          autoOk
          views={["year"]}
          format="yyyy"
          label={<Text tId="INDIVIDUAL_FINANCIAL_DATA_DATE" />}
          id="selfEmploymentNetIncomeDate"
          name="selfEmploymentNetIncomeDate"
          error={errors.selfEmploymentNetIncomeDate ? true : false}
          helperText={errors.selfEmploymentNetIncomeDate?.message}
          disableFuture={true}
          rules={{
            required: {
              value: true,
              message: <Text tId={"REQUIRED_FIELD"} />,
            },
            validate: {
              validate: (value) =>
                validateKeyboardInputDate({ value, disableFuture: true }),
            },
          }}
        />
      </Box>
      <Box>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
}
